import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Icon } from '@livable/saas-react-components';
import { Box, Button, Menu } from '@mui/material';
import React, { useState } from 'react';
import { DOWNLOAD_OPTIONS } from './billsDownload';

/** The chevron at the end of Download: down while its options are folded away, up once they're shown. */
const CHEVRON = {
  display: 'inline-flex',
  marginLeft: 'auto',
  '& .MuiSvgIcon-root': {
    marginRight: 0
  }
};
const CHEVRON_OPEN = _objectSpread(_objectSpread({}, CHEVRON), {}, {
  transform: 'rotate(180deg)'
});
/** Download's options sit under its label: the menu's padding, plus the icon and the gap after it. */
const DOWNLOAD_OPTION = {
  paddingLeft: '50px'
};

/** Row actions for the bills table: the "…" trigger with the options behind it. */
export function BillActionsMenu(_ref) {
  let _ref$canDelete = _ref.canDelete,
    canDelete = _ref$canDelete === void 0 ? true : _ref$canDelete,
    _ref$canPush = _ref.canPush,
    canPush = _ref$canPush === void 0 ? false : _ref$canPush,
    _ref$canRetry = _ref.canRetry,
    canRetry = _ref$canRetry === void 0 ? false : _ref$canRetry,
    deleteDisabledHint = _ref.deleteDisabledHint,
    downloadDisabledHint = _ref.downloadDisabledHint,
    _ref$isDownloading = _ref.isDownloading,
    isDownloading = _ref$isDownloading === void 0 ? false : _ref$isDownloading,
    onDelete = _ref.onDelete,
    onDownload = _ref.onDownload,
    onPush = _ref.onPush,
    onRetry = _ref.onRetry,
    onViewDetails = _ref.onViewDetails,
    pushDisabledHint = _ref.pushDisabledHint,
    retryDisabledHint = _ref.retryDisabledHint,
    _ref$showPush = _ref.showPush,
    showPush = _ref$showPush === void 0 ? false : _ref$showPush;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDownloadOpen = _useState4[0],
    setIsDownloadOpen = _useState4[1];
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
    setIsDownloadOpen(false);
  };
  const runAndClose = action => () => {
    handleClose();
    action();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    "aria-controls": open ? 'bill-actions-menu' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "true",
    "aria-label": "Bill actions",
    onClick: event => setAnchorEl(event.currentTarget),
    size: "small",
    state: open ? 'active' : undefined,
    variant: "actionIcon"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "dotdotdot"
  })), /*#__PURE__*/React.createElement(Menu, {
    anchorEl: anchorEl,
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    elevation: 0,
    id: "bill-actions-menu",
    onClose: handleClose,
    open: open,
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    type: "action-menu"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: runAndClose(onViewDetails),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "zoom-in"
  }), "View details"), showPush ? /*#__PURE__*/React.createElement("span", {
    title: pushDisabledHint || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !canPush,
    onClick: runAndClose(onPush),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "upload"
  }), "Push to AppFolio")) : null, onDownload ? /*#__PURE__*/React.createElement("span", {
    title: downloadDisabledHint || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-expanded": isDownloadOpen,
    disabled: Boolean(downloadDisabledHint) || isDownloading,
    onClick: () => setIsDownloadOpen(isOpen => !isOpen),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "file-download"
  }), "Download", /*#__PURE__*/React.createElement(Box, {
    component: "span",
    sx: isDownloadOpen ? CHEVRON_OPEN : CHEVRON
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-down",
    fontSize: "small"
  })))) : null, onDownload && isDownloadOpen ? DOWNLOAD_OPTIONS.map(option => /*#__PURE__*/React.createElement(Button, {
    key: option.kind,
    onClick: runAndClose(() => onDownload(option.kind)),
    sx: DOWNLOAD_OPTION,
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: option.icon
  }), option.oneBillLabel)) : null, onRetry ? /*#__PURE__*/React.createElement("span", {
    title: canRetry ? undefined : retryDisabledHint || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !canRetry,
    onClick: runAndClose(onRetry),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "reload"
  }), "Retry")) : null, /*#__PURE__*/React.createElement("span", {
    title: canDelete ? undefined : deleteDisabledHint || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    disabled: !canDelete,
    onClick: runAndClose(onDelete),
    variant: "menuAction"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "trash"
  }), "Delete"))));
}